import { ButtonType } from '../../constants/ButtonType';
import { PlateScanType } from '../../constants/PlateScanType';

export class RedoConfiguration {
	redoConfigurationName: string;
	changeToStep: string;
	changeToStepPosition: ButtonType;
	changeToStatus: string;
	changeToPlateIDType: PlateScanType;
	setSingleSampleRedo: boolean = false;
}

export class RedoConfigurationDTO{
	id: number;
	redoConfigName: string = "";
	changeStatusTo: RedoConfigurationDTOChangeStatus;
	changePlateType: PlateScanType;
}

export class RedoConfigurationDTOChangeStatus{
	status: string;
	step: string;
	stepActionType: ButtonType;
}

export class PredefinedRedoConfiguration{

	static RECEPTION_REDO: RedoConfiguration = {
		redoConfigurationName: "Reception Redo",
		changeToStep: "",
		changeToStepPosition: ButtonType.START,
		changeToStatus: "REDO",
		changeToPlateIDType: null,
		setSingleSampleRedo: true,
	}

	static NO_REDO: RedoConfiguration = {
		redoConfigurationName: "No Redo",
		changeToStep: "",
		changeToStepPosition: null,
		changeToStatus: "NO_REDO",
		changeToPlateIDType: null,
		setSingleSampleRedo: false,
	}

	static QC_PASSED: RedoConfiguration = {
		redoConfigurationName: "QC Passed",
		changeToStep: "",
		changeToStepPosition: null,
		changeToStatus: "QC_PASSED",
		changeToPlateIDType: null,
		setSingleSampleRedo: false,
	}
}